import { FOfferType } from '../../../utils/offer_type';

export const getSpecialtyTitle = (offerType: FOfferType) => {
  return offerType === FOfferType.Business ? 'Сфера деятельности: ' : 'Возможное назначение';
};
